import { omitBy, flatten, isEmpty, isNil, toString } from 'lodash-es';

export function flattenObject(obj: Record<string, any>): Record<string, any> {
	const toReturn: Record<string, any> = {};

	for (const key in obj) {
		// eslint-disable-next-line no-prototype-builtins
		if (!obj.hasOwnProperty(key)) continue;

		if (typeof obj[key] == 'object' && obj[key] !== null) {
			const flatObject = flattenObject(obj[key]);

			for (const innerKey in flatObject) {
				// eslint-disable-next-line no-prototype-builtins
				if (!flatObject.hasOwnProperty(innerKey)) continue;

				toReturn[key + '.' + innerKey] = flatObject[innerKey];
			}
		} else {
			toReturn[key] = obj[key];
		}
	}
	return toReturn;
}

export const filterEmptyValues = (value: any) =>
	omitBy(omitBy(value, isNil), (val) => typeof val === 'object' ? isEmpty(val) : toString(val) === '');

export const chunkIntoN = <T>(arr: T[], n: number): T[][] => {
	const minChunkSize = Math.floor(arr.length / n);
	const remainder = arr.length - minChunkSize * n;
	const chunkSizes = Array.from({ length: n }, (v, index) =>
		index + 1 <= remainder ? minChunkSize + 1 : minChunkSize
	);

	return chunkSizes.reduce<T[][]>((chunks, size) => {
		const start = flatten(chunks).length;

		return [...chunks, arr.slice(start, start + size)];
	}, []);
};
